// src/components/404Page.tsx
import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
      bgcolor="background.default"
      padding={3}
    >
      <Typography variant="h1" component="h1" color="textPrimary" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" component="h2" color="textPrimary" gutterBottom>
        ไม่พบหน้าที่ต้องการ
      </Typography>
      <Typography variant="body1" color="textSecondary">
        เราไม่พบหน้าที่คุณต้องการค้นหา ขออภัยในความไม่สะดวก
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/")}
        sx={{ mt: 2 }}
      >
        หน้าแรก
      </Button>
    </Box>
  );
};

export default NotFoundPage;
